module.exports = __webpack_public_path__ + "media/images/logos/linkedin-bg-f033675fd98aa3d72d1a9ca47bc9f93a.png";